<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>成果データのダウンロード方法（SLVRbullet）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】<a
            href="https://www.slvrbullet.com/pt/sign_in"
            target="_blank"
            rel="noopener noreferrer"
            >SLVRbulletの管理画面</a
          >にログインしたら、「成果一覧」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no02/01.png`" alt="" />
        <h4>【２】「表示項目」をクリックし、「クリックパラメータ」と「リファラ」にチェックをいれます。【１回だけ】</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no02/02.png`" alt="" />
        <h4>【３】期間を選択して、「レポートを表示する」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no02/03.png`" alt="" />
        <h4>【４】成果が表示されたら、「クリックパラメータ」にクリックパラメータ（{{tool.clickIdName}}_xxx）が表示されているか確認します。</h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/no07/no02/04.png`" alt="" />
        <p class="red">
          ※パラメータが表示されていない場合、パラメータ引継ぎ設定を間違えている可能性があります。
        </p>
        <p>
          「<router-link :to="`/manual/${tool.codeKebab}/06/02`">パラメータ引継ぎタグを設置する</router-link
          >」をご確認ください。
        </p>
        <h4>
          【５】CSVをダウンロードします。「CSVでダウンロード」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/no07/no02/05.png`" alt="" />
        <p>
          これで成果CSVのダウンロードは完了です。「<router-link
            :to="`/manual/${tool.codeKebab}/07/14`"
            >ASPの成果データをアドタスカルにインポートする</router-link
          >」に進んでください。
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManualGoogleCvContents",
  props: {},
  computed: {
    ...mapGetters(["rt","tool"]),
    tools() {
      return this.$store.getters.tools;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
